import { useState } from "react";
import downIcon from "../../assets/icons/chevron-down.png";
import { Button1, Select } from "../index";
import { useCreditReport } from "../../data/live";

const sectionTitle = (section) =>
  section.title || section.name || section.category || "Credit report section";

const CreditReportOverview = () => {
  const [showField, setShowField] = useState({});
  const { profile, loading } = useCreditReport();
  const factors = profile?.factors || {};
  const sections = Array.isArray(factors.overviewSections)
    ? factors.overviewSections
    : [];

  const onDownClick = (key) => {
    setShowField((current) => ({ ...current, [key]: !current[key] }));
  };

  if (loading) {
    return (
      <div className="d-flex flex-column gap-3 mt-3 border rounded-3 p-5 text-center text-muted">
        Loading credit report...
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="d-flex flex-column gap-3 mt-3 border rounded-3 p-5 text-center text-muted">
        No credit profile available.
      </div>
    );
  }

  return (
    <>
      <div className="d-flex flex-column gap-3 mt-3 border rounded-3 p-3 px-4">
        <span className="fs-5 fw-medium">Credit Report Overview</span>

        {sections.length ? (
          sections.map((section, key) => (
            <div
              key={section.id || sectionTitle(section)}
              className="d-flex flex-column gap-3 rounded-3 border p-3 px-4"
            >
              <div className="d-flex justify-content-between align-items-center ">
                <span
                  className="fs-6 fw-medium"
                  style={{ color: showField[key] ? "#161616" : "#7D7D7D" }}
                >
                  {sectionTitle(section)}
                  {section.count !== undefined ? ` (${section.count})` : ""}
                </span>
                <img
                  src={downIcon}
                  alt="down"
                  className="cursor-pointer"
                  width={24}
                  style={{
                    transform: `${
                      showField[key] ? "rotate(180deg)" : "rotate(0deg)"
                    }`,
                  }}
                  height={24}
                  onClick={() => onDownClick(key)}
                />
              </div>

              {showField[key] && (
                <div className="d-flex flex-column gap-2 gap-md-1">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-md-0 gap-2 ">
                    <span className="fs-6" style={{ color: "#1BBB6B" }}>
                      {section.provider || profile.bureau || "Credit provider"}
                    </span>
                    {section.date && (
                      <Select
                        defaultValue={new Date(section.date).toLocaleDateString("en-AU")}
                        className="rounded-pill w-auto"
                      />
                    )}
                  </div>

                  {section.description && (
                    <div className="text-center text-md-start">
                      <span style={{ fontSize: "18px" }}>
                        {section.description}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="p-5 text-center text-muted border rounded-3">
            No credit report sections available.
          </div>
        )}

        <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
          Credit report data is shown only when returned by the backend credit
          profile cache.
        </span>

        <Button1
          buttonName={"Something doesn't look right?"}
          className={"btn-dark align-self-end my-3"}
        />
      </div>
    </>
  );
};

export default CreditReportOverview;
